/**
 * Utility functions for unlock-related operations
 */

/**
 * Determines the unlock type based on the number of candidates
 * @param userIds - Single user ID or array of user IDs
 * @returns "SINGLE" if one candidate, "BULK" if more than one
 */
export const getUnlockType = (
  userIds: number | number[]
): "SINGLE" | "BULK" => {
  const candidateIds = Array.isArray(userIds) ? userIds : [userIds];
  return candidateIds.length > 1 ? "BULK" : "SINGLE";
};
